import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
function AngleRightDuotoneGlyph(props, svgRef) {
    return (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 512", focusable: "false", "aria-hidden": true, ref: svgRef }, props, { children: [_jsx("path", { d: "M128.14 256l56.47 56.49L88.46 409a23.76 23.76 0 01-33.6.18l-.18-.18-22.51-22.68a23.92 23.92 0 010-33.84z", opacity: 0.4 }, void 0),
            _jsx("path", { d: "M54.58 103.07L32 125.81a23.92 23.92 0 000 33.84L184.61 312.5 224 273l.06-.06a24 24 0 00-.16-33.94L88.37 103l-.17-.18a23.78 23.78 0 00-33.62.22z", className: "prefix__fa-primary" }, void 0)] }), void 0));
}
const ForwardRef = React.forwardRef(AngleRightDuotoneGlyph);
export default ForwardRef;
